import Form from './Form'
import validationOfFields from './validation'
import initialValuesOfFields from './initial-values'

export default Form
export { validationOfFields, initialValuesOfFields }
